import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ReactSelect from 'components/theme/Select'
import { groupOptionsSelector } from 'selectors'
import { handleGroupChange } from 'actions/signupForm/addOrEdit'
import { FormHelperText } from '@material-ui/core'
import language from 'utils/vast-languagepack'

const customStyles = {
  control: provided => ({
    ...provided,
    borderRadius: '28px',
    padding: '9px 0',
  }),
  menu: provided => ({
    ...provided,
    zIndex: 2,
  }),
}

export default connect(
  state => ({
    value: state.signupForm.addOrEdit.groupSelect.value,
    error: state.signupForm.addOrEdit.groupSelect.error,
    options: groupOptionsSelector(state),
  }),
  dispatch => bindActionCreators({ handleGroupChange }, dispatch),
)(({ value, options, handleGroupChange, error }) => (
  <div>
    <ReactSelect
      styles={customStyles}
      value={value}
      onChange={newValue => handleGroupChange(newValue)}
      closeMenuOnSelect={false}
      isMulti
      options={options}
      placeholder={language.general.shared.selectGroup}
    />
    {error ? (
      <FormHelperText error={Boolean(error)}>{error}</FormHelperText>
    ) : null}
  </div>
))
